var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "253px",
    height: "230px",
    viewBox: "0 0 253 230",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "buildings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.537255 0 0 0 0 0.607843 0 0 0 0 0.862745 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.537255 0 0 0 0 0.607843 0 0 0 0 0.862745 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BP-Creation-Form",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.178289
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-BP---Floor-number",
    transform: "translate(-646.000000, -302.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(138.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(163.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "create-event-card-copy",
    transform: "translate(1.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(33.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(311.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "office"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.998,29 C46.258,29 45.658,28.3850168 45.658,27.6265375 L45.658,19.3734625 C45.658,18.6149832 46.258,18 46.998,18 C47.742,18 48.342,18.6149832 48.342,19.3734625 L48.342,27.6265375 C48.342,28.3850168 47.742,29 46.998,29",
    id: "Fill-2",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7758635,226 L129,226 L129.114222,36.6477563 L82.8900853,4.20911629 L82.7758635,226 Z M81.3329744,228.873443 C80.5318479,228.873443 79.8857782,228.231093 79.8857782,227.43458 L80,1.43844961 C80,0.898876188 80.3014992,0.410690714 80.783898,0.162315649 C81.2576824,-0.086059417 81.8391452,-0.0475184585 82.2784726,0.265091538 L131.392694,34.7335554 C131.776029,34.9990598 132,35.4358573 132,35.9069135 L131.885778,227.438862 C131.885778,228.231093 131.244016,228.873443 130.442889,228.873443 L81.3329744,228.873443 Z",
    id: "Fill-4",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7801706,226 L70,226 L69.1099147,46.8448099 L22.8900853,46.8448099 L23.7801706,226 Z M22.3329744,228.84481 C21.5361551,228.84481 20.8900853,228.204622 20.8900853,227.420285 L20,45.4202851 C20,44.6359486 20.6460697,44 21.4428891,44 L70.5528038,44 C71.3539303,44 72,44.6359486 72,45.4202851 L72.8900853,227.420285 C72.8900853,228.204622 72.2440156,228.84481 71.4428891,228.84481 L22.3329744,228.84481 Z",
    id: "Fill-6",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,226 L20.3347416,226 L20.1652584,68.8760716 L8.8305169,68.8760716 L9,226 Z M7.58474155,228.876072 C6.80318091,228.876072 6.1694831,228.228848 6.1694831,227.435893 L6,67.4401789 C6,66.642937 6.63369781,66 7.41525845,66 L21.5805169,66 C22.3663022,66 23,66.642937 23,67.4401789 L23.1694831,227.435893 C23.1694831,228.228848 22.5357853,228.876072 21.75,228.876072 L7.58474155,228.876072 Z",
    id: "Fill-8",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.601205,75 C81.1879241,75 80.7829924,74.8183434 80.5074718,74.467704 L69.3071426,60.3027148 C68.8228943,59.6901519 68.9230836,58.7987672 69.5242195,58.3087169 C70.1295298,57.8228911 71.0103608,57.9200563 71.4946091,58.5326192 L82.6949382,72.7018329 C83.175012,73.3101713 83.0789972,74.2015559 82.4736868,74.6916063 C82.2148645,74.8986103 81.9059475,75 81.601205,75",
    id: "Fill-9",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.564063,229.342 L1.43593726,229.342 C0.642956981,229.342 0,228.742 0,228.002 C0,227.258 0.642956981,226.658 1.43593726,226.658 L136.564063,226.658 C137.357043,226.658 138,227.258 138,228.002 C138,228.742 137.357043,229.342 136.564063,229.342",
    id: "Fill-10",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8343894,44.248975 L60.1656106,44.248975 L60.1656106,38.7469251 L31.8343894,38.7469251 L31.8343894,44.248975 Z M61.5849174,47 L30.4193067,47 C29.6336191,47 29,46.3850168 29,45.6224376 L29,37.3734625 C29,36.6149832 29.6336191,36 30.4193067,36 L61.5849174,36 C62.3621568,36 63,36.6149832 63,37.3734625 L63,45.6224376 C63,46.3850168 62.3663809,47 61.5849174,47 L61.5849174,47 Z",
    id: "Fill-11",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8305169,35.248975 L52.1652584,35.248975 L52.1652584,29.7469251 L40.8305169,29.7469251 L40.8305169,35.248975 Z M53.5847416,38 L39.4110338,38 C38.6336978,38 38,37.3850168 38,36.6224376 L38,28.3734625 C38,27.6149832 38.6336978,27 39.4110338,27 L53.5847416,27 C54.3663022,27 55,27.6149832 55,28.3734625 L55,36.6224376 C55,37.3850168 54.3663022,38 53.5847416,38 L53.5847416,38 Z",
    id: "Fill-12",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "30 59 36 59 36 53 30 53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "39 59 45 59 45 53 39 53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "48 59 54 59 54 53 48 53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "56 59 62 59 62 53 56 53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "90 47 96 47 96 36 90 36"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "99 47 105 47 105 36 99 36"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "108 47 114 47 114 36 108 36"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "117 47 123 47 123 36 117 36"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "90 62 96 62 96 51 90 51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "99 62 105 62 105 51 99 51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "108 62 114 62 114 51 108 51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "117 62 123 62 123 51 117 51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "90 76 96 76 96 65 90 65"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "99 76 105 76 105 65 99 65"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "108 76 114 76 114 65 108 65"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "117 76 123 76 123 65 117 65"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "90 91 96 91 96 80 90 80"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "99 91 105 91 105 80 99 80"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "108 91 114 91 114 80 108 80"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "117 91 123 91 123 80 117 80"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "90 105 96 105 96 94 90 94"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "99 105 105 105 105 94 99 94"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-35",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "108 105 114 105 114 94 108 94"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "117 105 123 105 123 94 117 94"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "90 119 96 119 96 108 90 108"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "99 119 105 119 105 108 99 108"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "108 119 114 119 114 108 108 108"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "117 119 123 119 123 108 117 108"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "30 68 36 68 36 62 30 62"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "39 68 45 68 45 62 39 62"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "48 68 54 68 54 62 48 62"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "56 68 62 68 62 62 56 62"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "30 76 36 76 36 70 30 70"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "39 76 45 76 45 70 39 70"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "48 76 54 76 54 70 48 70"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "56 76 62 76 62 70 56 70"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "30 85 36 85 36 79 30 79"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-50",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "39 85 45 85 45 79 39 79"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-51",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "48 85 54 85 54 79 48 79"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "56 85 62 85 62 79 56 79"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-53",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "30 94 36 94 36 88 30 88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-54",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "39 94 45 94 45 88 39 88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-55",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "48 94 54 94 54 88 48 88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-56",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "56 94 62 94 62 88 56 88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-57",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "30 103 36 103 36 97 30 97"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "39 103 45 103 45 97 39 97"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-59",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "48 103 54 103 54 97 48 97"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-60",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "56 103 62 103 62 97 56 97"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-61",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "30 111 36 111 36 105 30 105"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-62",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "39 111 45 111 45 105 39 105"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-63",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "48 111 54 111 54 105 48 105"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-64",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "56 111 62 111 62 105 56 105"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-2)",
    id: "Residential"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6386752,15.9386201 C39.8062377,15.9386201 39.9775238,15.9729716 40.1376391,16.0454915 L96.1370201,41.0839371 L100.996332,32.1945256 L36.4512645,2.77816879 L3.06909469,33.209804 L10.1253369,40.4465255 L38.8455461,16.2325165 C39.0726864,16.0378578 39.3519572,15.9386201 39.6386752,15.9386201 M96.6732201,44 C96.5056576,44 96.3380951,43.9656485 96.1779798,43.8931286 L39.8397502,18.7058263 L10.8402702,43.160296 C10.3413064,43.580148 9.61520228,43.5419797 9.16092177,43.0763256 L0.365753338,34.0609585 C0.123718643,33.8128641 -0.00660773077,33.4731657 0.000258103026,33.1181999 C0.00828671197,32.767051 0.16095475,32.4349862 0.421607498,32.1983424 L35.3825882,0.323943093 C35.7698437,-0.0272058393 36.3097673,-0.0920920551 36.7528769,0.12546761 C36.7975603,0.140734955 36.8459672,0.156002299 36.8943741,0.178903317 L103.260287,30.4235136 C103.580518,30.5685533 103.822553,30.8471824 103.937985,31.1906976 C104.045969,31.5303961 104.012457,31.904446 103.841171,32.2212434 L97.764238,43.3435042 C97.5370977,43.7595393 97.1163297,44 96.6732201,44",
    id: "Fill-2",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2410771,75 C11.5557062,75 11,74.448365 11,73.7680151 L11,40.2319849 C11,39.551635 11.5557062,39 12.2410771,39 C12.9301527,39 13.4821542,39.551635 13.4821542,40.2319849 L13.4821542,72.5360302 L90.5141411,72.5360302 L90.5141411,41.6996322 C90.5141411,41.0192824 91.0698473,40.4676474 91.7589229,40.4676474 C92.4442938,40.4676474 93,41.0192824 93,41.6996322 L93,73.7680151 C93,74.448365 92.4442938,75 91.7589229,75 L12.2410771,75 Z",
    id: "Fill-4",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4035768,59.6689861 L81.6,59.6689861 L81.6,53.834493 C81.6,51.9035785 79.9868852,50.334493 78.0017884,50.334493 C76.0166915,50.334493 74.4035768,51.9035785 74.4035768,53.834493 L74.4035768,59.6689861 Z M82.7982116,62 L73.2017884,62 C72.5400894,62 72,61.4816103 72,60.834493 L72,53.834493 C72,50.6163022 74.6932936,48 78.0017884,48 C81.3102832,48 84,50.6163022 84,53.834493 L84,60.834493 C84,61.4816103 83.4599106,62 82.7982116,62 L82.7982116,62 Z",
    id: "Fill-6",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4,59.6689861 L71.6,59.6689861 L71.6,53.834493 C71.6,51.9035785 69.9868852,50.334493 68.0017884,50.334493 C66.0166915,50.334493 64.4,51.9035785 64.4,53.834493 L64.4,59.6689861 Z M72.7982116,62 L63.2017884,62 C62.5365127,62 62,61.4816103 62,60.834493 L62,53.834493 C62,50.6163022 64.6897168,48 67.9982116,48 C71.3067064,48 74,50.6163022 74,53.834493 L74,60.834493 C74,61.4816103 73.4599106,62 72.7982116,62 L72.7982116,62 Z",
    id: "Fill-8",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4007156,59.6689861 L60.5992844,59.6689861 L60.5992844,53.834493 C60.5992844,51.9035785 58.9856887,50.334493 57,50.334493 C55.0143113,50.334493 53.4007156,51.9035785 53.4007156,53.834493 L53.4007156,59.6689861 Z M61.8014311,62 L52.1985689,62 C51.5366726,62 51,61.4816103 51,60.834493 L51,53.834493 C51,50.6163022 53.6905188,48 57,48 C60.3094812,48 63,50.6163022 63,53.834493 L63,60.834493 C63,61.4816103 62.4597496,62 61.8014311,62 L61.8014311,62 Z",
    id: "Fill-10",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3758852,72.5477837 L38.6241148,72.5477837 L38.6241148,50.4522163 L24.3758852,50.4522163 L24.3758852,72.5477837 Z M39.810287,75 L23.1861722,75 C22.5311219,75 22,74.4509963 22,73.7738918 L22,49.2261082 C22,48.5490037 22.5311219,48 23.1861722,48 L39.810287,48 C40.4688781,48 41,48.5490037 41,49.2261082 L41,73.7738918 C41,74.4509963 40.4688781,75 39.810287,75 L39.810287,75 Z",
    id: "Fill-12",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7518629,62.34 L30.2518629,62.34 C29.5625931,62.34 29,61.74 29,61 C29,60.256 29.5625931,59.66 30.2518629,59.66 L32.7518629,59.66 C33.4411326,59.66 34,60.256 34,61 C34,61.74 33.4411326,62.34 32.7518629,62.34",
    id: "Fill-14",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.753247,75.34 L5.24675325,75.34 C4.56029685,75.34 4,74.74 4,74 C4,73.256 4.56029685,72.66 5.24675325,72.66 L114.753247,72.66 C115.443414,72.66 116,73.256 116,74 C116,74.74 115.443414,75.34 114.753247,75.34",
    id: "Fill-15",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5,47.429606 C104.151405,47.429606 101.429089,50.1525027 101.429089,53.5018104 C101.429089,56.8511182 104.151405,59.5740149 107.5,59.5740149 C110.848595,59.5740149 113.570911,56.8511182 113.570911,53.5018104 C113.570911,50.1525027 110.848595,47.429606 107.5,47.429606 M107.5,62 C102.811968,62 99,58.1872204 99,53.5018104 C99,48.8127796 102.811968,45 107.5,45 C112.184412,45 116,48.8127796 116,53.5018104 C116,58.1872204 112.184412,62 107.5,62",
    id: "Fill-16",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.002,75 C107.258,75 106.658,74.4409243 106.658,73.7513977 L106.658,56.2523295 C106.658,55.5628028 107.258,55 108.002,55 C108.742,55 109.342,55.5628028 109.342,56.2523295 L109.342,73.7513977 C109.342,74.4409243 108.742,75 108.002,75",
    id: "Fill-17",
    fill: "#F7F8FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "24 40 29 40 29 33 24 33"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "32 40 37 40 37 33 32 33"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "40 40 45 40 45 33 40 33"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "48 40 53 40 53 33 48 33"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#F7F8FD",
    fillRule: "nonzero",
    points: "56 40 61 40 61 33 56 33"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.4584f786e714f9c08792024f0baa6755.svg";
export { ForwardRef as ReactComponent };